<template>
  <div style="width: 100%">
    <v-container class="px-8 py-5">
      <v-row class="justify-center">
        <v-col cols="12">
          <v-row class="body-2 font-weight-light">
            <v-breadcrumbs class="breadcrumbs pa-0" :items="breadcrumbs"></v-breadcrumbs>
            <v-spacer></v-spacer>
            <span>{{$todayDate()}}</span>
          </v-row>
        </v-col>
        <v-col cols="12" sm="10" md="8">
          <v-treeview
            :items="educationalFields"
            open-on-click
            id="tree"
          >
            <template slot="append" slot-scope="props">
              <v-btn 
                icon
                @click.stop="addDialog = true; currentField = props.item;"
              >
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <template slot="label" slot-scope="props">
              <span 
              @click.stop="editDialog = true; currentField = props.item;"
              style="cursor: pointer;"
              >
                {{props.item.name}}
              </span>
            </template>
          </v-treeview>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
      v-model="addDialog"
      width="500"
      @click:outside="closeDialog"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
            <v-toolbar-title>Dodajte smjer za "{{currentField.name}}"</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn @click.native="closeDialog" dark icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-form ref="form">
            <v-row>
              <v-col cols="4">
                <v-subheader>Naziv smjera: </v-subheader>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  outlined
                  dense
                  height="44"
                  hide-details
                  v-model="eduFieldName"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-subheader>Stupanj stručne spreme: </v-subheader>
              </v-col>
              <v-col cols="8">
                <v-text-field
                    outlined
                    dense
                    height="44"
                    hide-details
                    v-model="degree"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            height="44"
            class="text-none" 
            @click="closeDialog"
          >
            Odustani
          </v-btn>
          <v-btn 
            height="44"
            depressed
            class="primary text-none"
            @click="addEduField"
          >
            Potvrdi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="editDialog"
      width="500"
    >
      <v-card>
        <v-toolbar color="primary" dark class="elevation-0">
            <v-toolbar-title>Uređivanje smjera</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn @click.native="editDialog = false" dark icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-form ref="form">
            <v-row>
              <v-col cols="4">
                <v-subheader>Naziv smjera: </v-subheader>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  outlined
                  dense
                  height="44"
                  hide-details
                  v-model="currentField.name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-subheader>Stupanj stručne spreme: </v-subheader>
              </v-col>
              <v-col cols="8">
                <v-text-field
                    outlined
                    dense
                    height="44"
                    hide-details
                    v-model="currentField.degree"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            class="error--text text-none"
            text
            @click="deleteEduField"
          >
            Izbriši
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            height="44" 
            depressed
            class="text-none"
            @click="editDialog = false"
          >
            Odustani
          </v-btn>
          <v-btn 
            height="44"
            depressed
            class="primary text-none"
            @click="updateEduField"
          >
            Potvrdi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {serverBus} from "../../main";
/* import ApiV2 from "../../services/ApiV2" */

export default {
  name: 'Home',
  components: {
  },
  data: () => ({
    educationalFields: [],
    eduFieldName: '',
    searchValue: '',
    degree: '',
    currentField: {},
    addDialog: false,
    editDialog: false,
  }),
  computed: {
    breadcrumbs() {
      return [
        {
          text: 'Smjerovi',
          disabled: true
        }
      ]
    } 
  },
  methods: {
    closeDialog () {
      this.addDialog = false
      this.eduFieldName = ''
      this.degree = ''
    },

    getEducationalFields() {
      this.$axios.get(`/v2/educational_fields`, {
        params: {
          "filter[parent_id]": "n=",
          with: "children"
        }
      }).then(response => {
          this.educationalFields = response.data.data;
      });
    },
    addEduField() {
      this.$axios.post('/v2/educational_fields', {
        name: this.eduFieldName,
        degree: this.degree,
        parent_id: this.currentField.id
      }).then(() => {
        this.$refs.form.reset();
        this.getEducationalFields();
        this.addDialog = false;
        serverBus.$emit('show-snackbar', true, "Uspješno ste dodali novi smjer.");
      })
      .catch(() => {
        serverBus.$emit('show-snackbar', false);
      });
    },
    deleteEduField() {
      this.$axios.delete(`/v2/educational_fields/${this.currentField.id}`)
        .then(() => {
          this.editDialog = false;
          this.getEducationalFields();
          serverBus.$emit('show-snackbar', true, "Uspješno ste obrisali smjer.");
        })
        .catch(() => {
          serverBus.$emit('show-snackbar', false);
        });
    },
    updateEduField() {
      this.$axios.put(`/v2/educational_fields/${this.currentField.id}`, {
        name: this.currentField.name,
        degree: this.currentField.degree,
        parent_id: this.currentField.parent_id,
      }).then((response) => {
          this.educationalField = response.data
          this.editDialog = false;
          serverBus.$emit('show-snackbar', true, "Uspješno ste ažurirali podatke.");
        })
        .catch(() => {
          serverBus.$emit('show-snackbar', false);
        });
    }
  },
  mounted() {
    this.getEducationalFields();
  }
}
</script>

<style>
  #tree .v-treeview-node__root {
    border: thin solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }
</style>
